import ExecAPI from 'appRoot/api/api';

/**
 * Gets the status of the Ip2Location database update thread.
 */
export function GetIp2LocationDbUpdateStatus()
{
	return ExecAPI("AdminMisc/GetIp2LocationDbUpdateStatus");
}
/**
 * Manually triggers an update of the Ip2Location database.
 */
export function ManuallyTriggerIp2LocationDbUpdate()
{
	return ExecAPI("AdminMisc/ManuallyTriggerIp2LocationDbUpdate");
}
/**
 * Gets the status of the passkey provider list update thread.
 */
export function GetPasskeyProviderListUpdateStatus()
{
	return ExecAPI("AdminMisc/GetPasskeyProviderListUpdateStatus");
}
/**
 * Manually triggers an update of the passkey provider list.
 */
export function ManuallyTriggerPasskeyProviderListUpdate()
{
	return ExecAPI("AdminMisc/ManuallyTriggerPasskeyProviderListUpdate");
}